import React from "react";

const STATUS_STYLE = {
  DRAFT: { background: "#fff7ed", color: "#9a3412", border: "#fdba74" },
  ACTIVE: { background: "#ecfdf5", color: "#065f46", border: "#6ee7b7" },
  ARCHIVED: { background: "#f1f5f9", color: "#334155", border: "#cbd5e1" },
};

export default function WorkflowStatusBadge({ status }) {
  const style = STATUS_STYLE[status] || STATUS_STYLE.DRAFT;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        borderRadius: 999,
        padding: "2px 8px",
        border: `1px solid ${style.border}`,
        background: style.background,
        color: style.color,
        fontSize: 12,
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: 0.3,
      }}
    >
      {status || "DRAFT"}
    </span>
  );
}
